class SchmukoModal extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        this.addEventListener('click', (event) => {
            if (event.target === this.firstElementChild) this.hide();
        });
        this.querySelector('.button').addEventListener('click', (e) => {
            this.hide();
        })
    }

    setTitle(title) {
        this.querySelector('.schmuko-dialog-title').textContent = title;
    }

    setContent(content) {
        this.querySelector('.schmuko-dialog-content').textContent = content;
    }

    open() {
        this.classList.add('active');
    }

    hide() {
        this.classList.remove('active')
    }
}
customElements.define('schmuko-modal', SchmukoModal);